<template>
  <div style="position: relative" class="cursor-pointer">
    <q-carousel
      ref="carousel"
      animated
      v-model="slide"
      :height="`${this.height}px`"
      control-type="outline"
      infinite
      id="carousel"
      v-if="sectionData.slides.length"
    >
      <q-carousel-slide
        v-for="(item, i) in sectionData.slides"
        :key="i"
        :name="i"
        class="q-pa-none relative-position"
        @click.stop="() => {}"
      >
        <div class="fit carousel-image-container" ref="image">
          <img
            :style="[
              {
                position: 'absolute',
                overflow: 'hidden',
                opacity: `${loading ? 0 : 1}`,
              },
              imgStyle,
            ]"
            ref="img"
            @load="imgLoad"
            @error="(ev) => onError(ev, cid, item.section)"
            :data-src="imageUrl"
            data-label="carousel-image"
            v-show="!loading"
          />
        </div>

        <div
          class="row items-center justify-center full-height full-width bg-grey-2 carousel-image-container loader"
          v-show="loading"
        >
          <q-spinner-dots size="md" color="secondary" />
        </div>
      </q-carousel-slide>
      <template v-if="sectionData.slides.length > 1" v-slot:control>
        <q-carousel-control
          position="left"
          :offset="[10, height / 2 - 33.59 / 2]"
          class="q-gutter-xs"
        >
          <q-btn
            push
            round
            dense
            style="background-color: rgba(0, 0, 0, 0.55)"
            text-color="white"
            size="12.5px"
            @click="previousImage"
          >
            <q-icon name="arrow_left" size="20px" />
          </q-btn>
        </q-carousel-control>
        <q-carousel-control
          position="right"
          :offset="[10, height / 2 - 33.59 / 2]"
          class="q-gutter-xs"
        >
          <q-btn
            push
            round
            dense
            style="background-color: rgba(0, 0, 0, 0.55)"
            text-color="white"
            size="12.5px"
            @click="nextImage"
          >
            <q-icon name="arrow_right" size="20px" />
          </q-btn>
        </q-carousel-control>
      </template>
    </q-carousel>
    <div
      v-if="slideTitle || slideFeatured || slideOverline || slideCaption"
      :class="`title q-pa-md text-white full-width column items-${contentAlign} text-${textAlign}`"
    >
      <div
        v-if="slideFeatured && showFeatured"
        style="
          color: black;
          height: 30px;
          border-radius: 2px;
          background: #ffd600;
          max-width: calc(100% - 40px);
        "
        class="row items-center content-center no-wrap justify-center q-mb-sm"
      >
        <div
          v-if="
            (typeof slideFeatured === 'boolean' || slideFeatured.boolean) &&
            !slideFeatured.tooltip
          "
        >
          <q-icon
            class="q-pl-sm"
            style="margin-top: -2px"
            name="star"
            size="17px"
          />
        </div>
        <div v-if="slideFeatured.tooltip">
          <q-icon
            class="q-pl-sm"
            :name="
              slideFeatured.tooltip.icon ? slideFeatured.tooltip.icon : 'star'
            "
            size="17px"
          >
            <q-tooltip>{{ slideFeatured.tooltip.text }}</q-tooltip>
          </q-icon>
        </div>
        <div
          :class="`q-pl-sm q-pr-sm`"
          style="
            text-transform: uppercase;
            font-weight: 700;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
        >
          <DDynamicText
            v-if="slideFeatured.dynamic"
            :dynamic="slideFeatured.dynamic"
            :parentMetas="parentMetas"
            @show="showOrHideDynamic('showFeatured', $event)"
          />
          <span v-else-if="slideFeatured.text">{{ slideFeatured.text }}</span>
          <span v-else>Featured</span>
        </div>
      </div>
      <div
        v-if="slideOverline"
        style="
          font-size: 1em;
          font-weight: 700;
          text-transform: uppercase;
          opacity: 0.8;
        "
      >
        <DDynamicText
          v-if="slideOverline.dynamic"
          :dynamic="slideOverline.dynamic"
          :parentMetas="parentMetas"
        />
        <span v-else>{{ slideOverline }}</span>
      </div>
      <div v-if="slideTitle" style="font-size: 1.2em; font-weight: bold">
        <DDynamicText
          v-if="slideTitle.dynamic"
          :dynamic="slideTitle.dynamic"
          :parentMetas="parentMetas"
        />
        <span v-else>{{ slideTitle }}</span>
      </div>
      <div v-if="slideCaption" style="font-size: 1em; font-weight: 500">
        <DDynamicText
          v-if="slideCaption.dynamic"
          :dynamic="slideCaption.dynamic"
          :parentMetas="parentMetas"
        />
        <span v-else>{{ slideCaption }}</span>
      </div>
    </div>

    <div
      class="action-btns top row items-center justify-end"
      @click.stop.prevent="() => {}"
      v-if="sectionData.slides.length"
    >
      <q-btn
        class="btn"
        rounded
        dense
        color="black"
        text-color="white"
        size="11.67px"
        @click="invokeComponent"
        icon="open_in_full"
        v-if="componentExists(this.sectionData.id, 'DFullScreenCarousel')"
      />
    </div>

    <div
      class="carousel-no-images bg-secondary"
      v-if="!sectionData.slides.length && (showVt || showPdfs)"
    ></div>

    <div
      class="action-btns bottom row items-center justify-end"
      @click.stop.prevent="() => {}"
      v-if="showVt || showPdfs"
    >
      <div class="column items-center justify-center" v-if="showVt">
        <q-btn
          class="btn bg-white"
          rounded
          dense
          outline
          color="secondary"
          size="20px"
          @click="openVt"
        >
          <q-img
            :class="`vtbg bg-${vtBg}`"
            src="../../../../assets/icons/vt-360.png"
            height="24px"
            width="24px"
            @load="changeVtBg()"
          />
        </q-btn>

        <div class="text-uppercase text-secondary btn-label text-weight-bold">
          tour
        </div>
      </div>

      <div class="column items-center justify-center" v-if="showPdfs">
        <q-btn
          class="btn bg-white"
          rounded
          dense
          outline
          color="secondary"
          size="11.67px"
          :icon="currentPdf.icon"
          @click="openPdfs"
        />

        <div class="text-uppercase text-secondary btn-label text-weight-bold">
          {{ currentPdf.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../d-card-mixins";
import getImgUrl from "../../mixins/get-img-url";
import DDynamicText from "../../components/DDynamicText/DDynamicText.vue";

export default {
  name: "DCarousel",
  mixins: [mixin, getImgUrl],
  components: {
    DDynamicText,
  },
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
    storePath: {
      type: String,
      required: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    scrollerHeight: {
      type: Number,
      default: 0,
    },
    layout: {
      type: Object,
      required: true,
    },
    parentMetas: {
      type: Object,
      require: false,
      default: () => {},
    },
    virtualtours: {
      type: Object,
      require: false,
      default: () => {},
    },
    pdfs: {
      type: [Object, Array],
      require: false,
      default: null,
    },
    currrentPage: {
      type: Number,
      require: false,
      default: 0,
    },
    componentExists: {
      type: [Function, null],
      default: () => false,
    },
    cid: {
      type: String,
      default: "cenora",
    },
    mediaManagerRequestUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      lslide: 0,
      width: 0,
      height: 0,
      loading: true,
      showFeatured: true,
      vtBg: "transparent",
      observer: null,
      imageUrl: "",
    };
  },
  computed: {
    objectFit: {
      get() {
        if (this.sectionData.slides[this.slide]?.objectFit) {
          return this.sectionData.slides[this.slide].objectFit;
        } else {
          return "center";
        }
      },
    },
    imgStyle: {
      get() {
        if (this.sectionData.slides[this.slide]?.style) {
          return this.sectionData.slides[this.slide].style;
        } else {
          return "center";
        }
      },
    },
    slide: {
      get() {
        return this.lslide;
      },
      set(val) {
        this.lslide = val;
      },
    },
    slideTitle: {
      get() {
        return this.sectionData.slides[this.slide]?.title !== undefined
          ? this.sectionData.slides[this.slide].title
          : "";
      },
    },
    slideOverline: {
      get() {
        return this.sectionData.slides[this.slide]?.overline !== undefined
          ? this.sectionData.slides[this.slide].overline
          : "";
      },
    },
    slideCaption: {
      get() {
        return this.sectionData.slides[this.slide]?.caption !== undefined
          ? this.sectionData.slides[this.slide].caption
          : "";
      },
    },
    slideFeatured: {
      get() {
        return this.sectionData.slides[this.slide]?.featured !== undefined
          ? this.sectionData.slides[this.slide].featured
          : false;
      },
    },
    contentAlign: {
      get() {
        if (this.sectionData.slides[this.slide]?.textAlign !== undefined) {
          switch (this.sectionData.slides[this.slide].textAlign) {
            case "left":
              return "start";
            case "right":
              return "end";
            default:
              return "center";
          }
        } else {
          return "center";
        }
      },
    },
    textAlign: {
      get() {
        if (this.sectionData.slides[this.slide]?.textAlign !== undefined) {
          return this.sectionData.slides[this.slide].textAlign;
        } else {
          return "center";
        }
      },
    },
    showVt: {
      get() {
        return this.virtualtours?.section?.body?.data?.slides?.length;
      },
    },
    showPdfs: {
      get() {
        return !!this.currentPdf;
      },
    },
    currentPdf: {
      get() {
        if (this.pdfs instanceof Array) {
          return this.pdfs[this.currrentPage];
        }

        return this.pdfs;
      },
    },
  },
  async mounted() {
    if (this.behavior === "consumer") {
      this.$cardStore.subscribe("images", (data, copy) => {
        if (!copy[this.storePath]) {
          return;
        }

        const value = JSON.parse(copy[this.storePath]);

        if (value.slide === undefined || value.slide === this.lslide) {
          return;
        }

        this.lslide = value.slide;
      });
    }

    await this.setImage(0, false);

    if (this.$refs.image[0]) {
      if (this.behavior === "agent") {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) {
              return;
            }

            const img = entries[0].target.querySelector(
              "[data-label='carousel-image']:not([src])"
            );

            if (img.getAttribute("data-src").includes("Promise")) {
              return;
            }

            if (!img || img.src) {
              this.observer.disconnect();
              return;
            }

            img.src = img.getAttribute("data-src");
            this.observer.disconnect();
          },
          {
            rootMargin: "2500px",
            threshold: 0,
          }
        );

        this.observer.observe(this.$refs.image[0]);
      }
    }

    this.width =
      this.behavior === "agent"
        ? this.layout.appearance.width
        : window.innerWidth;

    if (this.$refs.carousel) {
      this.$refs.carousel.$el.style.width = this.width;
      this.$refs.carousel.$el.style.maxWidth = this.width;
    }
    let ratio = 8 / 5;
    if (this.sectionData?.ratio !== undefined) {
      ratio = this.sectionData.ratio;
    }
    if (this.$refs.carousel) {
      this.$refs.carousel.$el.style.maxWidth = this.width;
    }
    if (this.sectionData.style?.height) {
      if (typeof this.sectionData.style.height === "number") {
        this.height = this.sectionData.style.height;
        return;
      }
      const fixedHeight =
        this.behavior === "agent"
          ? this.layout.appearance.height - 51
          : window.innerHeight - 51;
      const fixedWidth =
        this.behavior === "agent"
          ? this.layout.appearance.width
          : window.innerWidth;
      this.height = eval(
        this.sectionData.style.height
          .split("fullWidth")
          .join(`${fixedWidth}`)
          .split("full")
          .join(`${fixedHeight}`)
      );
      return;
    }

    this.$nextTick(() => {
      if (ratio === 0) {
        this.height = this.scrollerHeight;
      } else {
        this.height = this.layout.appearance.width / ratio;
        if (isNaN(this.height)) {
          this.height = this.scrollerHeight / ratio;
        }
      }
    });
  },
  watch: {
    lslide() {
      this.loading = true;
    },
    scrollerHeight: {
      immediate: true,
      handler() {
        if (this.sectionData.style?.height) {
          return;
        }

        let ratio = 8 / 5;
        if (this.sectionData?.ratio !== undefined) {
          ratio = this.sectionData.ratio;
        }

        if (ratio === 0) {
          this.height = this.scrollerHeight;
        } else {
          this.height = this.layout.appearance.width / ratio;
          if (isNaN(this.height)) {
            this.height = this.scrollerHeight / ratio;
          }
        }
      },
    },
    slide(val) {
      this.setImage(val);
    },
  },
  methods: {
    async setImage(index, execLoad = true) {
      const item = this.sectionData.slides[index];

      this.imageUrl = await this.getImgUrl({
        ...item,
        url: `${this.sectionData.baseUrl}${item.src}`,
        mediaManagerRequestUrl: this.mediaManagerRequestUrl,
      });

      if (this.behavior !== "agent" || execLoad) {
        this.$nextTick(() => {
          this.execLoadImage();
        });
      }
    },
    execLoadImage() {
      this.$nextTick(() => {
        const img = this.$refs.image[0].querySelector(
          "[data-label='carousel-image']:not([src])"
        );

        if (!img || img.src) {
          return;
        }

        img.src = img.getAttribute("data-src");
      });
    },
    async previousImage() {
      const slide =
        this.slide <= 0 ? this.sectionData.slides.length - 1 : this.slide - 1;
      this.$cardStore.set(this.storePath, JSON.stringify({ slide }));

      if (this.behavior === "agent") {
        this.lslide = slide;
        return;
      }

      this.slide = slide;
    },
    async nextImage() {
      const slide =
        this.slide >= this.sectionData.slides.length - 1 ? 0 : this.slide + 1;
      this.$cardStore.set(this.storePath, JSON.stringify({ slide }));

      if (this.behavior === "agent") {
        this.lslide = slide;
        return;
      }

      this.slide = slide;
    },
    imgLoad(ev) {
      if (!this.$refs.img[0]) {
        return;
      }

      if (this.objectFit === "top") {
        this.$refs.img[0].style.width = "100%";
      } else if (this.objectFit === "contain") {
        this.$refs.img[0].style.height = `${this.height}px`;
        this.$refs.img[0].style.left = "50%";
        this.$refs.img[0].style.transform = "translate(-50%, 0)";
      } else if (
        this.isPortrait(ev.target.naturalHeight, ev.target.naturalWidth)
      ) {
        this.$refs.img[0].style.height = `${this.height}px`;
        this.$refs.img[0].style.left = "50%";
        this.$refs.img[0].style.transform = "translate(-50%, 0)";
      } else {
        this.$refs.img[0].style.width = "100%";
        this.$refs.img[0].style.top = "50%";
        this.$refs.img[0].style.transform = "translate(0, -50%)";
      }

      this.loading = false;
    },
    isPortrait(height, width) {
      if (!height || !width) {
        return true;
      }

      const finalWidth = (this.height * width) / height;

      return finalWidth >= this.width;
    },
    invokeComponent() {
      this.$emit("invokeComponent", {
        component: "DFullScreenCarousel",
        id: this.sectionData.id,
        state: {
          slide: this.slide,
        },
      });
    },
    showOrHideDynamic(prop, value) {
      this[prop] = value;
    },
    openVt() {
      this.$emit("invokeComponent", {
        component: "DVirtualTourComponent",
        id: this.virtualtours.section.body.data.id,
        state: {
          slide: this.virtualtours.section.body.data.slides[0],
          slides: this.virtualtours.section.body.data.slides,
        },
      });
    },
    openPdfs() {
      this.$emit("invokeComponent", {
        component: "DPdfViewer",
        id: this.currentPdf.id,
      });
    },
    changeVtBg() {
      setTimeout(() => {
        try {
          this.vtBg = "secondary";
        } catch (error) {}
      }, 250);
    },
  },
  beforeUnmount() {
    if (!this.observer) {
      return;
    }

    this.observer.disconnect();
    this.observer = null;
  },
};
</script>
<style scoped>
.title {
  position: absolute;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  z-index: 20;
}
</style>

<style lang="scss">
#carousel {
  .q-panel {
    overflow: hidden !important;
  }
}

.carousel-no-images {
  padding-top: 30px;
}

.action-btns {
  position: absolute;
  z-index: 99999;

  .btn {
    width: 40px;
    height: 40px;
  }

  &.top {
    top: 12px;
    right: 12px;

    .btn {
      background-color: rgba($color: #000000, $alpha: 0.5) !important;
    }
  }

  &.bottom {
    bottom: -30px;
    right: 19px;

    .btn {
      &-label {
        font-size: 8px;
        line-height: 10px;
        padding-top: 2px;
      }
    }
  }

  > div {
    &:not(:first-child) {
      margin-left: 16px;
    }
  }
}

.vtbg {
  transition: background-color ease 0s !important;
}

.carousel-image-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;

  &.loader {
    z-index: 6;
  }
}

.q-carousel__control {
  z-index: 15;
}
</style>
